import { render } from "./LearnerCentral.vue?vue&type=template&id=7ddb855c"
import script from "./LearnerCentral.vue?vue&type=script&lang=js"
export * from "./LearnerCentral.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__